/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SearchInputWithSelect = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleSearch = () => {
    if (!searchTerm.trim()) return;
    navigate(`/orders?search=${encodeURIComponent(searchTerm)}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="flex items-center my-3 w-full max-w-3xl mx-auto border-2 border-[#9b59bf] dark:!border-[#a06bb7] rounded-lg overflow-hidden bg-white dark:!bg-[#181919]">
      <input
        type="text"
        placeholder={t("navbar.searchlaceholder")}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={handleKeyDown}
        className="flex-1 px-4 py-2 border-none focus:outline-none placeholder:text-gray-400 text-[#9e68ba] bg-transparent text-right"
      />

      <button
        onClick={handleSearch}
        className="px-4 py-2.5 bg-[#9b59bf] text-white hover:bg-[#814a9f] transition-colors duration-200 focus:outline-none"
        aria-label={t("Products.ImportModal.search")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </svg>
      </button>
    </div>
  );
};

export default SearchInputWithSelect;
